export const DRAGGABLE_QUESTION_TYPE = "registration-questions";
export const CUSTOM_QUESTION_LIMIT = 10;
